// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Navigation-module--wrapper--2NOzV","menu":"Navigation-module--menu--3Mvl9","header":"Navigation-module--header--jNjqB","list":"Navigation-module--list--SRFdk"};